module.exports = __webpack_public_path__ + "img/notopic.e3b1d2b0.svg";